import React from 'react';
import Table from './Table';
import Badge from './Badge';

const FollowUpsTable = ({ followups, overdueCount, onViewAll, onNavigate }) => {
  return (
    <div className="card" style={{ 
      background: 'var(--color-background-primary)', 
      padding: '24px', 
      borderRadius: 'var(--border-radius-xl)',
      border: '1px solid var(--color-border-tertiary)',
      boxShadow: 'var(--shadow-sm)',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h3 style={{ fontSize: '16px', fontWeight: '600' }}>Today's Follow-ups</h3>
        {onViewAll && (
          <button 
            onClick={onViewAll}
            style={{ 
              padding: '6px 12px', 
              borderRadius: 'var(--border-radius-md)', 
              border: '1px solid var(--color-border-primary)',
              background: 'var(--color-background-secondary)',
              fontSize: '12px',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'background 0.2s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = 'var(--color-border-tertiary)'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'var(--color-background-secondary)'}
          >
            View all
          </button>
        )}
      </div>
      
      {overdueCount > 0 && (
        <div style={{ 
          background: '#FCEBEB', 
          border: '1px solid #F7C1C1', 
          borderRadius: 'var(--border-radius-md)', 
          padding: '12px 16px', 
          fontSize: '13px', 
          color: '#A32D2D', 
          marginBottom: '16px',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          fontWeight: '500'
        }}>
          <span role="img" aria-label="warning">⚠️</span> {overdueCount} overdue follow-ups need attention
        </div>
      )}

      {followups && followups.length > 0 ? (
        <div style={{ flex: 1, overflowX: 'auto' }}>
          <Table 
            headers={['Lead', 'Type', 'Assigned To', 'Due', 'Status']}
            data={followups}
            renderRow={(item) => (
              <>
                <td 
                  style={{ padding: '14px 16px', fontWeight: '600', cursor: 'pointer', color: 'var(--color-brand-primary)' }}
                  onClick={() => onNavigate && onNavigate(`/lead/${item._id}`)}
                >
                  {item.name}
                </td>
                <td style={{ padding: '14px 16px', fontSize: '13px', color: 'var(--color-text-secondary)' }}>{item.type}</td>
                <td style={{ padding: '14px 16px', fontSize: '13px', color: 'var(--color-text-secondary)' }}>{item.assigned}</td>
                <td style={{ padding: '14px 16px', fontSize: '13px', fontWeight: '500' }}>{item.due}</td>
                <td style={{ padding: '14px 16px' }}>
                  <Badge type={item.statusType}>{item.status}</Badge>
                </td>
              </>
            )}
          />
        </div>
      ) : (
        <div style={{ 
          padding: '40px', 
          textAlign: 'center', 
          color: 'var(--color-text-tertiary)', 
          fontSize: '14px',
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '12px',
          background: 'var(--color-background-secondary)',
          borderRadius: 'var(--border-radius-lg)',
          border: '1px dashed var(--color-border-secondary)'
        }}>
          <div style={{ fontSize: '32px' }}>📅</div>
          <div>No follow-ups scheduled for today.</div>
        </div>
      )}
    </div>
  );
};

export default FollowUpsTable;
